import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SpritePool from '../common/SpritePool';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import Critter from './Critter';

export default class FishManager extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.fishPool = null;
    this.activeFish = null;

    this.isDraggable = true;

    this.maxTop = null;
    this.maxRight = null;
    this.maxBottom = null;
    this.maxRight = null;

    this.fishPool = new SpritePool(this.scene, Critter, gameData.MAX_FISH * 2);

    /** @type {Critter[]} */
    this.activeFish = [];

    this.once(Phaser.GameObjects.Events.DESTROY, () => this.fishPool.cleanup());
  }

  scatterOffscreen () {
    const len = this.activeFish.length;
    let scatterDir;
    for (let i = 0; i < len; i++) {
      const f = this.activeFish[i];
      f.removeAllListeners();
      f.on('FISH_ARRIVED_TO_DEST', () => this.doneWithFish(f));
      f.unhighlight();
      f.doAnimatedSwim();
      scatterDir = Phaser.Math.Between(0,100) < 50 ? 1 : -1;
      const dx = scatterDir > 0 ? this.scene.scale.width + 100 : -100;
      scatterDir = Phaser.Math.Between(0,100) < 50 ? 1 : -1;
      const dy = scatterDir > 0 ? Phaser.Math.Between(0,this.scene.scale.height / 2) : (this.scene.scale.height / 2,this.scene.scale.height);
      f.initializeSwimTo(dx,dy);
    }
  }

  doneWithFish (fish) {
    this.returnFish(fish);
    if (this.activeFish.length === 0) {
      this.emit('ALL_FISH_DONE');
    }
  }

  /**
   * 
   * @param {Critter} item 
   */
  returnFish (item) {
    item.removeAllListeners();
    this.remove(item);
    this.fishPool.returnSprite(item);
    const index = this.activeFish.indexOf(item);
    this.activeFish.splice(index,1);
  }

  bringInCountedFish (num, destRects) {
    // Shuffle the spliced array once more for good measure
    Phaser.Utils.Array.Shuffle(destRects);
    let waitTimer = 0;
    const waitInc = 1000 / num;
    for (let i = 0; i < num; i++) {
      // left or right
      const dir = Phaser.Math.Between(0,10) > 5 ? -200 : this.scene.scale.width + 200;
      const sp = { x: dir,y: Phaser.Math.Between(60,this.scene.scale.height - 220) };
      let ep = { x: Phaser.Math.Between(160,this.scene.scale.width - 160),y: Phaser.Math.Between(60,this.scene.scale.height - 220) };
      if (destRects) {
        let aRect = destRects.splice(0,1);
        aRect = aRect[0];
        ep = { x: aRect.x, y: aRect.y };
      }

      const f = this.makeFish(sp,Phaser.Math.Between(1,9));
      f.homePos = ep;
      this.scene.time.delayedCall(waitTimer, this.waitToSwimIn,[f,ep.x, ep.y], this);
      waitTimer += waitInc;
      f.on('FISH_ARRIVED_TO_DEST', () => this.fishArrived(f));
      f.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, pointer => this.onClickFish(f, pointer));
      if (this.isDraggable) {
        f.on(Phaser.Input.Events.GAMEOBJECT_DRAG,pointer => this.onDragFish(f, pointer));
        f.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.onReleaseFish(f));
      }
    }
  }

  makeFish (startPt, fishType) {
    /** @type {Critter} */
    const item = this.fishPool.getSprite();
    item.visible = true;
    item.reset(startPt, 'Fish', fishType);
    this.add(item);
    this.activeFish.push(item);
    return item;
  }

  /**
   * 
   * @param {Critter} fish 
   * @param {number} x 
   * @param {number} y 
   */
  waitToSwimIn (fish, x,y) {
    fish.initializeSwimTo(x,y);
  }

  /**
   * 
   * @param {Critter} critter 
   */
  fishArrived (critter) {
    const fish = critter;

    fish.initializeHover();
  }


  /**
   * 
   * @param {Critter} critter 
   * @param {Phaser.Input.Pointer} pointer 
   */
  onClickFish (critter, pointer) {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._touch_fish, this.scene);
    const fish = critter;
    this.add(fish);
    fish.stopSwimming();
    fish.offsetX = fish.x - pointer.x;
    fish.offsetY = fish.y - pointer.y;
    if (!fish.isHighlighted) {
      this.emit('FISH_HIGHLIGHTED');
    }
    fish.highlight();
  }

  /**
   * 
   * @param {Critter} critter 
   * @param {Phaser.Input.Pointer} pointer 
   */
  onDragFish (critter, pointer) {
    const fish = critter;
    const newx = pointer.x + fish.offsetX;
    const newy = pointer.y + fish.offsetY;

    if (newx < fish.x - 1) {
      fish.turnDir(-1);
    }
    else if (newx > fish.x + 1) {
      fish.turnDir(1);
    }
    fish.curPos.x = newx;
    fish.curPos.y = newy;
  }

  /**
   * 
   * @param {Critter} critter 
   */
  onReleaseFish (critter) {
    const fish = critter;

    // Check if it's offscreen
    const r1 = { x: 150,y: 150,width: this.scene.scale.width - 150 - 150,height: this.scene.scale.height - 200 - 150 };
    const r2 = { x: fish.x, y: fish.y, width: fish.getBounds().width, height: fish.getBounds().height };
    if (!Phaser.Geom.Rectangle.Overlaps(r1,r2)) {
      const destPos = { x: fish.x, y: fish.y };
      if (r1.x > r2.x) destPos.x = r1.x;
      if (r1.x + r1.width < r2.x) destPos.x = r1.x + r1.width;
      if (r1.y > r2.y) destPos.y = r1.y;
      if (r1.y + r1.height < r2.y) destPos.y = r1.y + r1.height;
      fish.initializeSwimTo(destPos.x, destPos.y);
    }
    else {
      fish.initializeHover();
    }
  }

  returnScaredFish () {
    const len = this.activeFish.length;
    for (let i = 0; i < len; i++) {
      const fish = this.activeFish[i];
      fish.isScared = false;
      fish.removeAllListeners();
      fish.on('FISH_ARRIVED_TO_DEST', () => this.fishArrived(fish));
      fish.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, pointer => this.onClickFish(fish, pointer));
      if (this.isDraggable) {
        fish.on(Phaser.Input.Events.GAMEOBJECT_DRAG,pointer => this.onDragFish(fish, pointer));
        fish.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.onReleaseFish(fish));
      }
      fish.initializeSwimTo(fish.homePos.x, fish.homePos.y);
    }
  }

  checkForFishToScare (x) {
    const len = this.activeFish.length;
    for (let i = 0; i < len; i++) {
      const f = this.activeFish[i];
      if (f.x < x) {
        if (!f.isScared) {
          this.scareFish(f);
        }
      }
    }
  }

  /**
   * 
   * @param {Critter} f 
   */
  scareFish (f) {
    const fish = f;
    fish.isScared = true;
    fish.removeAllListeners();

    let scatterDir = 1; // monster is coming from left
    const dx = scatterDir > 0 ? this.scene.scale.width + 100 : -100;
    scatterDir = Phaser.Math.Between(0,100) < 50 ? 1 : -1;
    const dy = scatterDir > 0 ? Phaser.Math.Between(0,this.scene.scale.height / 2) : (this.scene.scale.height / 2,this.scene.scale.height);
    f.initializeSwimTo(dx,dy);
  }

  tick (delta) {
    const len = this.activeFish.length - 1;
    for (let i = len; i >= 0; i--) {
      this.activeFish[i].tick(delta);
    }
  }
}